import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ValuationEventCurrenciesService {

  /**
  * External rate subject
  */
  private externalRateSubject = new BehaviorSubject<any>(null);

  /**
   * External rate observable
   */
  public externalRate = this.externalRateSubject.asObservable();

  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
  }

  /**
   * Loads currecies list with ISO code
   * @param reflistName reflistName
   */
  loadCurrenciesListWithISOCode(reflistName: string): Observable<any> {
    const resource = this.appServiceHelper.getServiceEndpoint('pollux.api', 'reflist');
    return this.httpClient.get<any>(`${resource}/pollux?reflistName=${reflistName}`);
  }

  /**
  * Loads currency rates
  * @param valuationEventId valuationEventId
  */
  loadCurrencyConversions(valuationEventId: number): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.currencies.api', `currencies/rates/valuationevent?valuationEventId=${valuationEventId}`));
  }

  /**
  * Loads currency rates from the Xignite API
  * @param date Date for which the rate should be fetched
  */
  getExternalRate(symbol: string, date: Date): Observable<any> {
    const month = (date.getUTCMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
    const day = (date.getUTCDate()).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
    const dateUtc = `${date.getUTCFullYear()}-${month}-${day}`;
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.currencies.api', `currencies/rates/query/historic?symbol=${symbol}&asOfDate=${dateUtc}`));
  }

  /**
 * Saves currency rates
 * @param valuationEventId valuationEventId
 * @param currencies currencies array
 */
  saveCurrencyConversions(valuationEventId: number, currencies: any): Observable<any> {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.currencies.api', `currencies/rates?valuationEventId=${valuationEventId}`), currencies);
  }

  /**
* Loads project currency id
* @param valuationEventId valuationEventId
*/
  loadProjectCurrencyId(valuationEventId: number): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.currencies.api', `currencies/rates/valuationevent/projectCurrency?valuationEventId=${valuationEventId}`));
  }

  /**
  * Sets external rate
  */
  setExternalRate(rate: any) {
    this.externalRateSubject.next(rate);
  }

  /**
 * Loads required rates for valuation event
 * @param valuationEventId valuationEventId
 * @param currencies currencies array
 */
  loadRequiredRates(valuationEventId: number): Observable<any[]> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.currencies.api', `currencies/rates/valuationevent/required?valuationEventId=${valuationEventId}`));
  }

}
